import axios from 'axios';
import { getHeaders, sendHash } from 'src/utils/Headers';

const apiCampus = process.env.REACT_APP_API_CAMPUS;
const apiPortalITC = process.env.REACT_APP_API_PORTAL_ITC;
const apiDocente = process.env.REACT_APP_API_DOCENTE;


export const inciarSesionMoodle = async (correo, contrasenha) => {
  const ruta = `${apiCampus}auth/login`

  const body = {
    email: correo,
    password: contrasenha
  }

  const response = await axios.post(ruta, body)
  return response.data;
}

export const iniciarSesionPortal = async (token) => {
  const ruta = `${apiPortalITC}login/loginItc`

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
  const response = await axios.post(ruta, {}, { headers });
  return response.data;
}

export const verificarEstudianteBloqueado = async (token ,codDirectorioEst) => {
  const ruta = `${apiDocente}itc/verificarEstudianteBloqueado`;

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
  const body = {
    cod_directorio_est : codDirectorioEst
  }


  const response = await axios.post(ruta,body,{headers});
  return response.data;
}


